import React from 'react'
import { useUserAPI } from '../../../../../providers/UserAPIProvider'
import MediaAvatar from '../../../../atoms/MediaAvatar'
import Tooltip from '../../../../atoms/Tooltip'
import useStyles from './styles'

interface CreatedByProps {
  client: any
}
const CreatedBy: React.FC<CreatedByProps> = ({ client }) => {
  const { allUsers, loadUser } = useUserAPI()
  const user = allUsers[client?.owner_id]

  const classes = useStyles()

  React.useEffect(() => {
    if (client?.owner_id && !allUsers[client?.owner_id]) {
      loadUser(client?.owner_id)
    }
  }, [allUsers, loadUser, client?.owner_id])

  if (!user) {
    return <div></div>
  }

  return (
    <Tooltip title={user?.name ?? ''} arrow>
      <div className={classes.root}>
        <MediaAvatar user={user} className={classes.avatar} />
        <label>{user?.name}</label>
      </div>
    </Tooltip>
  )
}

export default CreatedBy
